import { module } from 'stereomodularjs';
// Import navigation module from swiper


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Get cookie value for lastInventoryUrl
        let lastInventoryUrl = document.cookie.replace(/(?:(?:^|.*;\s*)lastInventoryUrl\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        if (lastInventoryUrl !== '') {
            // Redirect to lastInventoryUrl
            this.el.href = lastInventoryUrl;
        }


    }
}
